import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output
} from '@angular/core';
import {AgentInventorySetting, AgentInventoryConfigModel} from '../../models/inventory-setting.model';

require('./agent-inventory-settings-table-row.scss');
@Component({
  standalone: false,
  selector: 'app-agent-inventory-settings-table-row',
  templateUrl: './agent-inventory-settings-table-row.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AgentInventorySettingsTableRowComponent implements OnInit {

  @Input() setting: AgentInventorySetting;
  @Output() onEdit = new EventEmitter<AgentInventorySetting>();
  @Output() onRemove = new EventEmitter<string>();

  constructor(
    @Inject(ChangeDetectorRef) private cdr: ChangeDetectorRef,
    @Inject('confirmDialogService') private confirmDialogService: any,
    @Inject('agentInventoryDialogService') private agentInventoryDialogService: any
  ) {
  }

  ngOnInit() {

  }

  onRemoveRow(event?: Event) {
    const title = 'Delete Inventory Setting';
    const text = 'Are you sure you want to delete this inventory setting?';

    this.confirmDialogService.confirm(title, text, event)
      .then(() => {
        this.onRemove.emit();
      })
      .catch((error) => {
        console.log('Dialog Closed', error);
      });
  }

}

